<template lang="pug">
  #WtDisplayRichTextHTML.editor__content(v-html="html")
</template>

<script>
export default {
  name: "WtDisplayRichTextHTML",

  props: {
    html: {
      type: String,
      default: ""
    }
  }
};
</script>

<style lang="sass" scoped></style>
